/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeviceTypeDto } from '../../models/device-type-dto';

export interface GetDeviceTypes$Params {
}

export function getDeviceTypes(http: HttpClient, rootUrl: string, params?: GetDeviceTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceTypeDto>> {
  const rb = new RequestBuilder(rootUrl, getDeviceTypes.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeviceTypeDto>;
    })
  );
}

getDeviceTypes.PATH = '/api/nms/device-type';
